import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiSave } from "react-icons/fi";
import "./CreateProject.css";
import { projectAPI } from "../../services/api";
import SuccessModal from "../../components/SuccessModal/SuccessModal";
import { useLanguage } from "../../contexts/LanguageContext";

// 다국어 지원을 위한 번역 객체
// 다국어 지원을 위한 번역 객체
const translations = {
  ko: {
    backToDashboard: "돌아가기",
    createNewProject: "새 프로젝트 생성",
    projectName: "프로젝트 이름",
    projectNamePlaceholder: "프로젝트 이름을 입력하세요",
    projectDescription: "프로젝트 설명",
    projectDescriptionPlaceholder: "프로젝트에 대한 설명을 입력하세요",
    projectType: "프로젝트 유형",
    cancel: "취소",
    creating: "처리 중...",
    createProject: "프로젝트 생성",
    creationFailed: "프로젝트 생성에 실패했습니다.",
    errorMessage: "프로젝트 생성 중 오류가 발생했습니다. 다시 시도해주세요.",
    successMessage: "프로젝트가 성공적으로 생성되었습니다.",
    requiredField: " *",
  },
  en: {
    backToDashboard: "Back",
    createNewProject: "Create New Project",
    projectName: "Project Name",
    projectNamePlaceholder: "Enter project name",
    projectDescription: "Project Description",
    projectDescriptionPlaceholder: "Enter project description",
    projectType: "Project Type",
    cancel: "Cancel",
    creating: "Processing...",
    createProject: "Create Project",
    creationFailed: "Failed to create project.",
    errorMessage:
      "An error occurred while creating the project. Please try again.",
    successMessage: "Project has been created successfully.",
    requiredField: " *",
  },
  ja: {
    backToDashboard: "戻る",
    createNewProject: "新規プロジェクト作成",
    projectName: "プロジェクト名",
    projectNamePlaceholder: "プロジェクト名を入力してください",
    projectDescription: "プロジェクト説明",
    projectDescriptionPlaceholder: "プロジェクトの説明を入力してください",
    projectType: "プロジェクトタイプ",
    cancel: "キャンセル",
    creating: "処理中...",
    createProject: "プロジェクト作成",
    creationFailed: "プロジェクトの作成に失敗しました。",
    errorMessage:
      "プロジェクト作成中にエラーが発生しました。もう一度お試しください。",
    successMessage: "プロジェクトが正常に作成されました。",
    requiredField: " *",
  },
  "zh-CN": {
    backToDashboard: "返回",
    createNewProject: "创建新项目",
    projectName: "项目名称",
    projectNamePlaceholder: "请输入项目名称",
    projectDescription: "项目描述",
    projectDescriptionPlaceholder: "请输入项目描述",
    projectType: "项目类型",
    cancel: "取消",
    creating: "处理中...",
    createProject: "创建项目",
    creationFailed: "创建项目失败。",
    errorMessage: "创建项目时发生错误。请重试。",
    successMessage: "项目已成功创建。",
    requiredField: " *",
  },
  "zh-TW": {
    backToDashboard: "返回",
    createNewProject: "創建新項目",
    projectName: "項目名稱",
    projectNamePlaceholder: "請輸入項目名稱",
    projectDescription: "項目描述",
    projectDescriptionPlaceholder: "請輸入項目描述",
    projectType: "項目類型",
    cancel: "取消",
    creating: "處理中...",
    createProject: "創建項目",
    creationFailed: "創建項目失敗。",
    errorMessage: "創建項目時發生錯誤。請重試。",
    successMessage: "項目已成功創建。",
    requiredField: " *",
  },
  it: {
    backToDashboard: "Indietro",
    createNewProject: "Crea Nuovo Progetto",
    projectName: "Nome Progetto",
    projectNamePlaceholder: "Inserisci il nome del progetto",
    projectDescription: "Descrizione Progetto",
    projectDescriptionPlaceholder: "Inserisci la descrizione del progetto",
    projectType: "Tipo di Progetto",
    cancel: "Annulla",
    creating: "Elaborazione in corso...",
    createProject: "Crea Progetto",
    creationFailed: "Impossibile creare il progetto.",
    errorMessage:
      "Si è verificato un errore durante la creazione del progetto. Riprova.",
    successMessage: "Il progetto è stato creato con successo.",
    requiredField: " *",
  },
  fr: {
    backToDashboard: "Retour",
    createNewProject: "Créer un Nouveau Projet",
    projectName: "Nom du Projet",
    projectNamePlaceholder: "Entrez le nom du projet",
    projectDescription: "Description du Projet",
    projectDescriptionPlaceholder: "Entrez la description du projet",
    projectType: "Type de Projet",
    cancel: "Annuler",
    creating: "Traitement en cours...",
    createProject: "Créer le Projet",
    creationFailed: "Échec de la création du projet.",
    errorMessage:
      "Une erreur s'est produite lors de la création du projet. Veuillez réessayer.",
    successMessage: "Le projet a été créé avec succès.",
    requiredField: " *",
  },
  de: {
    backToDashboard: "Zurück",
    createNewProject: "Neues Projekt erstellen",
    projectName: "Projektname",
    projectNamePlaceholder: "Projektname eingeben",
    projectDescription: "Projektbeschreibung",
    projectDescriptionPlaceholder: "Projektbeschreibung eingeben",
    projectType: "Projekttyp",
    cancel: "Abbrechen",
    creating: "Verarbeitung...",
    createProject: "Projekt erstellen",
    creationFailed: "Projekt konnte nicht erstellt werden.",
    errorMessage:
      "Bei der Erstellung des Projekts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    successMessage: "Projekt wurde erfolgreich erstellt.",
    requiredField: " *",
  },
  es: {
    backToDashboard: "Volver",
    createNewProject: "Crear Nuevo Proyecto",
    projectName: "Nombre del Proyecto",
    projectNamePlaceholder: "Introduzca el nombre del proyecto",
    projectDescription: "Descripción del Proyecto",
    projectDescriptionPlaceholder: "Introduzca la descripción del proyecto",
    projectType: "Tipo de Proyecto",
    cancel: "Cancelar",
    creating: "Procesando...",
    createProject: "Crear Proyecto",
    creationFailed: "Error al crear el proyecto.",
    errorMessage:
      "Se produjo un error al crear el proyecto. Inténtelo de nuevo.",
    successMessage: "El proyecto se ha creado correctamente.",
    requiredField: " *",
  },
  ru: {
    backToDashboard: "Назад",
    createNewProject: "Создать новый проект",
    projectName: "Название проекта",
    projectNamePlaceholder: "Введите название проекта",
    projectDescription: "Описание проекта",
    projectDescriptionPlaceholder: "Введите описание проекта",
    projectType: "Тип проекта",
    cancel: "Отмена",
    creating: "Обработка...",
    createProject: "Создать проект",
    creationFailed: "Не удалось создать проект.",
    errorMessage:
      "При создании проекта произошла ошибка. Пожалуйста, попробуйте снова.",
    successMessage: "Проект успешно создан.",
    requiredField: " *",
  },
  pt: {
    backToDashboard: "Voltar",
    createNewProject: "Criar Novo Projeto",
    projectName: "Nome do Projeto",
    projectNamePlaceholder: "Digite o nome do projeto",
    projectDescription: "Descrição do Projeto",
    projectDescriptionPlaceholder: "Digite a descrição do projeto",
    projectType: "Tipo de Projeto",
    cancel: "Cancelar",
    creating: "Processando...",
    createProject: "Criar Projeto",
    creationFailed: "Falha ao criar o projeto.",
    errorMessage:
      "Ocorreu um erro ao criar o projeto. Por favor, tente novamente.",
    successMessage: "O projeto foi criado com sucesso.",
    requiredField: " *",
  },
  ar: {
    backToDashboard: "رجوع",
    createNewProject: "إنشاء مشروع جديد",
    projectName: "اسم المشروع",
    projectNamePlaceholder: "أدخل اسم المشروع",
    projectDescription: "وصف المشروع",
    projectDescriptionPlaceholder: "أدخل وصف المشروع",
    projectType: "نوع المشروع",
    cancel: "إلغاء",
    creating: "جاري المعالجة...",
    createProject: "إنشاء المشروع",
    creationFailed: "فشل في إنشاء المشروع.",
    errorMessage: "حدث خطأ أثناء إنشاء المشروع. يرجى المحاولة مرة أخرى.",
    successMessage: "تم إنشاء المشروع بنجاح.",
    requiredField: " *",
  },
  hi: {
    backToDashboard: "वापस जाएं",
    createNewProject: "नया प्रोजेक्ट बनाएं",
    projectName: "प्रोजेक्ट का नाम",
    projectNamePlaceholder: "प्रोजेक्ट का नाम दर्ज करें",
    projectDescription: "प्रोजेक्ट का विवरण",
    projectDescriptionPlaceholder: "प्रोजेक्ट का विवरण दर्ज करें",
    projectType: "प्रोजेक्ट का प्रकार",
    cancel: "रद्द करें",
    creating: "प्रक्रिया जारी है...",
    createProject: "प्रोजेक्ट बनाएं",
    creationFailed: "प्रोजेक्ट बनाने में विफल रहा।",
    errorMessage: "प्रोजेक्ट बनाते समय एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
    successMessage: "प्रोजेक्ट सफलतापूर्वक बनाया गया है।",
    requiredField: " *",
  },
};

const CreateProject = () => {
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    projectType: "EDC", // 기본값 EDC
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // 현재 언어에 따른 텍스트 가져오기
  const getText = (key) => {
    return translations[currentLanguage]?.[key] || translations["en"][key];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    try {
      // 실제 API 호출
      const response = await projectAPI.createProject(formData);

      if (!response.success) {
        throw new Error(response.message || getText("creationFailed"));
      }

      // 성공 모달 표시
      setShowSuccessModal(true);
    } catch (error) {
      console.error("프로젝트 생성 오류:", error);
      setError(error.message || getText("errorMessage"));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    // 대시보드로 리디렉션
    navigate("/dashboard");
  };

  return (
    <div className="create-project-container">
      {showSuccessModal && (
        <SuccessModal
          message={getText("successMessage")}
          onClose={handleCloseSuccessModal}
        />
      )}

      <div className="create-project-header">
        <button className="back-button" onClick={() => navigate("/dashboard")}>
          <FiArrowLeft /> {getText("backToDashboard")}
        </button>
        <h1>{getText("createNewProject")}</h1>
      </div>

      <div className="create-project-form-container">
        <form className="create-project-form" onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="name">
              {getText("projectName")}
              {getText("requiredField")}
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={getText("projectNamePlaceholder")}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">{getText("projectDescription")}</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder={getText("projectDescriptionPlaceholder")}
              rows={5}
            />
          </div>

          <div className="form-group">
            <label htmlFor="projectType">
              {getText("projectType")}
              {getText("requiredField")}
            </label>
            <select
              id="projectType"
              name="projectType"
              value={formData.projectType}
              onChange={handleChange}
              required
              disabled
            >
              <option value="EDC">EDC</option>
            </select>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={() => navigate("/dashboard")}
            >
              {getText("cancel")}
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting}
            >
              <FiSave />{" "}
              {isSubmitting ? getText("creating") : getText("createProject")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateProject;
